import script from "./Authentication.vue?vue&type=script&setup=true&lang=js"
export * from "./Authentication.vue?vue&type=script&setup=true&lang=js"

import "./Authentication.vue?vue&type=style&index=0&id=c6a8f4d4&lang=css"

const __exports__ = script;

export default __exports__